/* eslint-disable import/prefer-default-export */
// export const $backEndUrl = 'https://localhost:7005' // DEV
// export const $backEndUrl = 'http://localhost:5001' // Teste local
// export const $backEndUrl = 'http://189.85.67.148:5555' // Teste Staging
// export const $backEndUrl = 'http://189.85.66.254:5001' // Sem referência
export const $backEndUrl = 'https://staging-monitor-api.softwarehub.com.br' // Produção
